import { Flex, Text } from "@chakra-ui/react";
import { ExtendedContactDetails, Field } from "./extended-contact-details.types";
import { toDisplayValue } from "./extended-contact-details.utils";

interface Props {
  details: ExtendedContactDetails | null;
  field: Field;
}

export default function DetailRow(props: Props) {
  const display = toDisplayValue(props.details, props.field);

  return (
    <Flex borderBottomWidth={1} gap={4} justify="space-between" py={1}>
      <Text color="gray.600">{props.field.label}</Text>
      {display === null ? (
        <Text color="gray.400">—</Text>
      ) : (
        <Text fontWeight="medium" textAlign="end" whiteSpace="pre-wrap">
          {display}
        </Text>
      )}
    </Flex>
  );
}
